module.exports = "<calendar-component\n  options=\"$ctrl.options\"\n  on-click=\"$ctrl.clicked($event)\"\n  before-show-day=\"$ctrl.onDayRender($event)\"\n  on-hover-in=\"$ctrl.hoverIn($event)\"\n  on-hover-out=\"$ctrl.hoverOut($event)\"\n  ng-class=\"{ 'mobile': $ctrl.isMobileApp, 'responsiveMobile': $ctrl.isMobileApp }\"\n  is-mobile-app=\"$ctrl.isMobileApp\"\n  on-click-previous=\"$ctrl.onClickPrevious()\"\n  on-click-next=\"$ctrl.onClickNext()\"\n  date-today=\"$ctrl.dateToday\"\n></calendar-component>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/calendar/calendar.html
// module id = 1437
// module chunks = 0